export const environment = {
	production: false,
	googleApiKey: 'AIzaSyAIIYOxA7qeetFz6TuR1Qewc0Rrjhzx7ZU',
	// apiURL: 'https://web.vdintercambio.com',
    apiURL: 'https://web.vdintercambio.com',
	apiURLAuth: 'https://auth.vdintercambio.com',
	COOKIE_AUTH: '_vdi',
	COOKIE_FORM: '_vdif'
};
